import { ILessonAlert } from 'app/components/call/BookingDetails/LessonBookingDetails/LessonAlert';
import Button from 'app/components/call/BookingDetails/LessonBookingDetails/LessonOutcome/Button';
import {
  ButtonDirective,
} from 'app/components/call/BookingDetails/LessonBookingDetails/LessonOutcome/Button/ButtonDirective';
import FlexMarginGroup from 'app/components/layout/FlexMarginGroup';
import MarginGroup from 'app/components/layout/MarginGroup';
import AlertBox from 'app/components/presentation/alert/AlertBox';
import { ColorScheme } from 'app/components/presentation/buttons/ButtonClassNameA';
import Modal from 'app/components/presentation/modals/Modal';
import React, { ComponentType, FC, ReactNode, SVGProps } from 'react';

interface IModalHelperProps {
  alert: ILessonAlert | null;
  asset: ComponentType<SVGProps<SVGSVGElement>>;
  buttons: Array<{ colorScheme?: ColorScheme; directive: ButtonDirective }>;
  onClose: () => unknown;
  status: ReactNode;
  title: string;
}

/**
 * A helper to present consistently present lesson ended modals.
 */
const ModalHelper: FC<IModalHelperProps> = ({
  alert,
  asset: Asset,
  buttons,
  onClose,
  status,
  title,
}) => (
  <Modal
    buttons={
      <FlexMarginGroup center wrap>
        {buttons.map((button, i) => (
          <Button key={`${i}`} onClick={onClose} {...button} />
        ))}
      </FlexMarginGroup>
    }
    image={<Asset width="100%" />}
    onClose={onClose}
    title={title}
  >
    <MarginGroup margin="15px">
      {status}
      {alert !== null && <AlertBox children={alert.message} variant={alert.alertVariant} />}
    </MarginGroup>
  </Modal>
);

export default ModalHelper;
